import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    height: 100%;
    box-sizing: border-box;
    background: #EEF1F6;
    /* padding + gap deixam o fundo cinza aparecer em volta e entre os cards */
    padding: 16px;
    gap: 16px;
`;

export const Sidebar = styled.div`
    flex: 0 0 280px;
    max-width: 280px;
    background: #FFFFFF;
    border-radius: 14px;
    overflow: hidden;
`;

export const Content = styled.div`
    flex: 1;
    background: #FFFFFF;
    border-radius: 14px;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;
